<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
            <v-card>
                <v-toolbar color="purple lighten-5">
                    <v-btn icon @click="show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Historia Clínica Completa</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="4" sm="2" md="2">
                            <h6 color="black">Legajo: {{ leg }}</h6>
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <h6>Nombre: {{ nombre }}</h6>
                        </v-col>
                        <v-col cols="4" sm="3" md="3">
                            <h6>Fecha Nacimiento: {{ fnacimiento }}</h6>
                        </v-col>
                        <v-col cols="4" sm="3" md="3">
                            <h6>DNI: {{ dni }}</h6>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="4" md="4">
                            <h6>Grupo Sanguíneo: {{ grupo }}</h6>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <h6>Dirección: {{ direccion }}</h6>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <h6>Teléfono Particular: {{ telpersonal }}</h6>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="4" md="4">
                            <h6>Obra Social: {{ obrasocial }}</h6>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <h6>N° de Afiliado: {{ afiliado }}</h6>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <h6>Tel O. Social: {{ telosocial }}</h6>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <h6>Contacto: {{ contacto }}</h6>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <h6>Antecedentes Médicos: {{ antmed }}</h6>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <h6>Antecendentes Quirúrgicos: {{ antquir }}</h6>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <h6>Inmunizaciones: {{ inmun }}</h6>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <h6>Accidentes: {{ accidente }}</h6>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card color="red lighten-5" v-if="this.preocupacional == 'SI'">
                <v-card-title>
                    <v-row dense>
                        <v-col cols="6" sm="6" md="6">
                            Exámen Preocupacional
                        </v-col>
                        <v-col cols="3" sm="3" md="3">
                        </v-col>
                        <v-col cols="3" sm="3" md="3">
                            <h6>Fecha preocupacional: {{ fecha }}</h6>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <h6>Observaciones: {{ observ }}</h6>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <h6>Limitaciones: {{ limitaciones }}</h6>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="6" sm="4" md="4">
                            <h6>Riesgos: {{ riesgo }} - {{ otrosriesgos }}</h6>
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <h6>EPP a utilizar: {{ epp }}</h6>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <v-radio-group v-model="periodico" label="Exámen Periódico" row dense>
                                <v-radio label="SI" value="SI" color="red darken-2"></v-radio>
                                <v-radio label="NO" value="NO" color="red darken-2"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <h6>Frecuencia exámen periódico: {{ frecuencia }}</h6>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card class="py-0" color="red  lighten-2" v-if="this.listadoHC.length > 0">
                <v-card-text>
                    <v-data-table dense :headers="headers" :items="listadoHC" locale="es-ar" class="elevation-1"
                        :items-per-page="100" hide-default-footer :footer-props="{
                            itemsPerPageText: 'Items por página',
                        }">
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Historia Clínica</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>

                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon small color="purple" class="mr-2" v-on="on" v-bind="attrs"
                                        @click.stop="editarHC(item)">
                                        mdi-pencil
                                    </v-icon>
                                </template>
                                <span>editar HC</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon small color="red" class="mr-2" v-on="on" v-bind="attrs"
                                        @click.stop="borrarHC(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                                <span>borrar HC</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <v-card class="py-0" color="red lighten-3" v-if="this.listadoE.length > 0">
                <v-card-text>
                    <v-data-table dense :headers="headersE" :items="listadoE" locale="es-ar" class="elevation-1"
                        :items-per-page="100" hide-default-footer :footer-props="{
                            itemsPerPageText: 'Items por página',
                        }">
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Exámenes Periódicos</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>

                            </v-toolbar>
                        </template>

                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-form>
        <EditarHC :visible="showEditar" :codigo="editedItem.codhistclin" :leg="this.leg" @close="showEditar = false">
        </EditarHC>
    </v-dialog>
</template>

<script>
import axios from "../../../src/axios-auth";
import moment from "moment";
import EditarHC from "../Medicina/Editarhc.vue";
export default {
    components: { EditarHC },
    data: (vm) => ({
        showEditar: false,
        editedItem: {},
        editedIndex: -1,
        valid: false,
        lazy: false,
        legajo: "",
        dni: "",
        nombre: "",
        fnacimiento: "",
        grupo: "",
        direccion: "",
        telpersonal: "",
        obrasocial: "",
        afiliado: "",
        telosocial: "",
        contacto: "",
        antmed: "",
        antquir: "",
        accidente: "",
        inmun: "",
        preocupacional: "",
        fecha: "",
        observ: "",
        limitaciones: "",
        riesgo: "",
        otrosriesgos: "",
        epp: "",
        periodico: "",
        frecuencia: "",
        listadoHC: [],
        listadoE: [],
        headersE: [{
            text: "Tipo",
            align: "start",
            sortable: false,
            value: "tipo",
        },
        { text: "Fecha", value: "fecha", sortable: false },
        { text: "Observaciones", value: "observ", sortable: false },
        { text: "Seguimiento", value: "seguimiento", sortable: false },
        { text: "Dias", value: "dias", sortable: false },
        { text: "Limitaciones", value: "limitaciones", sortable: false },
        { text: "EPP", value: "epp", sortable: false },],

        headers: [
            { text: "Código", value: "codhistclin", sortable: false },
            {
                text: "Tipo",
                align: "start",
                sortable: false,
                value: "tipo",
            },
            { text: "Lugar", value: "lugar", sortable: false },
            { text: "Fecha", value: "fecha", sortable: false },
            { text: "Detalle", value: "histClinica", sortable: false },
            { text: "Baja", value: "baja", sortable: false },
            { text: "Alta", value: "alta", sortable: false },
            { text: "Control", value: "control", sortable: false },
            { text: "Dias", value: "dias", sortable: false },
            { text: "Editar", value: "actions", sortable: false },
        ],
    }),
    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.buscarDatospersonal();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$refs.form.resetValidation();
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    props: ["visible", "leg", "id"],
    methods: {
        buscarDatospersonal() {
            const leg = this.leg;
            const id = this.id;
            if (leg != null) {
                console.log("LEGAJO: " + leg);
                let self = this;
                axios
                    .get("/Medico/Informe?", {
                        params: {
                            legajo: leg,
                        },
                    })
                    .then((response) => {
                        self.legajo = response.data.legajo;
                        self.nombre = response.data.nombre;
                        self.dni = response.data.dni;
                        self.fnacimiento = moment(response.data.fnacimiento).format("DD/MM/YYYY");
                        self.direccion = response.data.direccion;
                        self.grupo = response.data.grupo;
                        self.telpersonal = response.data.telpersonal;
                        self.obrasocial = response.data.obrasocial;
                        self.afiliado = response.data.afiliado;
                        self.telosocial = response.data.telosocial;
                        self.contacto = response.data.contacto;
                        self.accidente = response.data.accidente;
                        self.antmed = response.data.antmed;
                        self.antquir = response.data.antquir;
                        self.inmun = response.data.inmun;
                        self.preocupacional = response.data.preocupacional;
                        self.riesgo = response.data.riesgos;
                        self.epp = response.data.epp;
                        self.fecha = response.data.fecha;
                        self.observ = response.data.observ;
                        self.limitaciones = response.data.limitaciones;
                        self.otrosriesgos = response.data.otrosRiesgos;
                        self.periodico = response.data.periodico;
                        self.frecuencia = response.data.frecuencia;
                        self.listadoHC = response.data.historiaclinica;
                        self.listadoE = response.data.periodicos;
                    })
                    .catch((error) => {
                        //self.listadotrazabilidad = [];
                        console.log(error);
                    });
            }
        },
        vaciarModels() { },

        editarHC(item) {
            this.editedIndex = this.listadoHC.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },

        borrarHC(item) {
            this.$swal({
                title: "Borrar HC",
                text: "¿Desea borrar Historia Clínica?",
                icon: "success",
                background: "#ececec",
                showClass: {
                    popup: "animate__animated animate__fadeInDown"
                },
                hideClass: {
                    popup: "animate__animated animate__fadeOutUp"
                },
                showCancelButton: true,
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then(result => {
                if (result.value) {
                    const codhistclin = item.codhistclin;
                    const legajo = this.leg;
                    console.log("HC ", codhistclin, "LEG ", legajo)
                    let self = this;
                    axios
                        .get("/Medico/BorrarHC?", {
                            params: {
                                codhistclin: codhistclin,
                                legajo: legajo,
                            }
                        })
                        .then(response => {
                            self.showAlert({
                                icon: "success",
                                title: "Historia Clinia borrado",
                                vm: this
                            });
                            setTimeout(self.volverlistado(), 1700);
                        })
                        .catch(error => {
                            self.showAlert({
                                icon: "error",
                                title: "El parte semanal no pudo ser borrado",
                                vm: this
                            });
                        });
                }
            });
        },
        volverlistado() {
            this.show = false
        }
    },
};
</script>